module.exports = __webpack_public_path__ + "static/img/coin.8b23542.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coin.png
// module id = jzCB
// module chunks = 1